import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule, AutoCompleteModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';

import { TagSelectorComponent } from "./tag-selector.component";

@NgModule({
    declarations: [
        TagSelectorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonsModule,
        DropDownsModule, AutoCompleteModule, MultiSelectModule 
    ],
    exports: [
        TagSelectorComponent
    ]
  })
  export class TagSelectorModule { }